import React from 'react'
import {classNames} from "../../../../util/util-helpers";

export default function CellButton({onClick, className, addClass, disabled, children, isTruncated = true}) {
    return <button
        className={classNames(
            className ?? "cursor-pointer leading-5 inline-flex py-0.5 -mx-2 px-2 rounded-btn text-left disabled:text-tm-gray-700 disabled:hover:text-tm-gray-700 disabled:hover:bg-transparent hover:text-primary text-primary-shade font-btn font-medium hover:bg-primary-transparent hover:text-tm-gray-900 focus-visible:bg-primary-transparent focus:outline-hidden focus:ring-0",
            addClass,
            isTruncated ? "truncate" : undefined
        )}
        disabled={disabled}
        onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onClick();
        }}>

        {children}

    </button>
}
